import React from 'react';
import { useSelector } from 'react-redux';
import { graphql } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@printdeal/ui-library';
import { FeatureConfig } from '@printdeal/feature-management/react';

import { getLayoutProps, getRedirectUrl } from '../components/my-account/helpers/account-helper';

// @ts-expect-error
import { selectors as customerSelectors } from '../store/slices/customerSlice';

import PrivateRoute from '../components/PrivateRoute';
import Layout from '../components/Layout';
import LayoutSection from '../components/layout-section/LayoutSection';
import MyAccount from '../components/my-account/components/MyAccount';

import { SystemPageSeoPropType } from '../types/systemPageSeo';
import { IPageContext, Paths } from '../types/gatsby';
import { Location } from '../types/Location';
import { Footer } from '../components/navigation/footer/Footer';

interface PageContent extends SystemPageSeoPropType {
  path: string;
  paths: Paths;
}

interface Props {
  data: {
    pageContent: PageContent;
  };
  pageContext: IPageContext;
}

export const query = graphql`
  query accountDashboardPage($locale: String) {
    pageContent: contentfulPageSystem(
      node_locale: { eq: $locale }
      pageSytemType: { eq: "accountDashboard" }
    ) {
      path
      paths
    }
  }
`;

const MyAccountPage = ({ data, pageContext }: Props) => {
  const location = useLocation() as Location;
  const { pageContent } = data;

  // TODO AS-1409 It should not be necessary to call these selectors at such a high level.
  //   Move them to where the data is actually being used.
  //   Update 2024-07-26, I've already removed most of them. The one below can also be improved.
  const customerGroupId: string = useSelector(customerSelectors.getCustomerGroupId);

  const newQuote = location.pathname.includes('/account/quoting/request/new');

  const redirectURL = getRedirectUrl(location);
  const layoutProps = getLayoutProps(location);

  return (
    <Layout localizedPaths={pageContext.localizedPaths} isSmallerSearchbar showFooter={!newQuote}>
      <LayoutSection {...layoutProps}>
        <PrivateRoute redirectUrl={redirectURL}>
          <div data-hj-suppress>
            <MyAccount baseURL={pageContent.path} />
          </div>
          <FeatureConfig id="segmented_group_config">
            {({ featureConfig }: any) => (
              featureConfig.variables?.groupId === customerGroupId ? (
                <Alert variant="info" isDismissible autoDismiss={10000} className="pd-fixed pd-bottom-4 pd-right-4">
                  <FormattedMessage
                    id="segmented.customer.alert.message.resellersSegmentedPricing"
                    defaultMessage="Your personal discount is active and will be calculated automatically"
                  />
                </Alert>
              ) : null
            )}
          </FeatureConfig>
        </PrivateRoute>
      </LayoutSection>
      {newQuote && <Footer />}
    </Layout>
  );
};

export default MyAccountPage;
